module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "feature-area section-padding2"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row flexJCenter"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {}, [_c('h3', {
    staticClass: "title borderABC"
  }, [_vm._v(_vm._s(_vm.introduceInfo[0].title))]), _vm._v(" "), _c('p', {
    staticClass: "titleShadow"
  }, [_vm._v(_vm._s(_vm.introduceInfo[0].subTitle))])])])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.introduceInfo[0].content)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "mb-3"
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.url,
      "alt": "古都旅游"
    }
  })])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23bc31b4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/module/introduce.vue
// module id = 96
// module chunks = 1